import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SportService, UserService } from '@app/core';
import { CommonService } from '@app/core/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, ReplaySubject, Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-pick-slip',
  templateUrl: './pick-slip.component.html',
  styleUrls: ['./pick-slip.component.scss'],
})
export class PickSlipComponent implements OnInit {
  @Output() removePick = new EventEmitter();
  parlay = false;
  confirm = false;
  Math = Math;
  public straight = '';
  parlayAmount = 0;
  unique = (Math.random() + 1).toString(36).substring(7);
  errorid: any = [];
  to_win = 0;
  total_stake = 0;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    public _sport: SportService,
    private _toast: ToastrService,
    private _user: UserService,
    public _common: CommonService
  ) { }

  ngOnInit(): void {
    this._sport.pickslip.pipe(takeUntil(this.destroyed$)).subscribe((slips) => {
      this.to_win = this.towin(slips);
      this.total_stake = this.totalStake(slips);
      if (this.parlay) {
        this.calculateParlay();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  removeItem(index: number) {
    let pickslip = this._sport.pickslip.getValue();
    let slip = pickslip[index];
    this._sport.market_ids.splice(
      this._sport.market_ids.indexOf(slip.marketid),
      1
    );
    if (slip.opposite_market_ids) {
      let opposites = slip.opposite_market_ids.split(',');
      opposites.forEach((id: any) => {
        this._sport.market_ids.splice(this._sport.market_ids.indexOf(id), 1);
      });
    }
    pickslip.splice(index, 1);
    this._sport.pickslip.next(pickslip);
    if (!pickslip.length) {
      this.confirm = false;
    }
    this.removePick.emit(pickslip.length);
  }

  setPickAmount(amount: any) {
    if (amount) amount = parseInt(amount);
    let pickslip = this._sport.pickslip.getValue();
    pickslip.forEach((slip) => {
      slip.bet_amount = amount;
    });
    this._sport.pickslip.next(pickslip);
  }

  removeAll() {
    if (confirm('Are you sure ?')) {
      this._sport.pickslip.next([]);
      this._sport.market_ids = [];
      this.parlay = false;
      this.to_win = 0;
      this.total_stake = 0;
      this.parlayAmount = 0;
    }
  }

  async placePicks() {
    let minMax: any = null;
    let slips = this._sport.pickslip.getValue();
    if (!slips.length) return;
    if (!this.parlay) {
      slips.forEach((slip) => {
        if (slip.bet_amount < 50 || slip.bet_amount > 1000) {
          minMax = slip.bet_amount;
        }
      });
    } else {
      if (this.parlayAmount < 50) {
        return this._toast.error('Minimum parlay amount should be $50.');
      } else if (this.parlayAmount > 100) {
        return this._toast.error('Maximum parlay amount should be $100.');
      } else {
        minMax = null;
      }
    }

    if (minMax == null) {
      let user = this._user.authUser.getValue();
      let obj: any = {
        user_id: user.id,
        bets: slips,
        parlay: this.parlay ? 1 : 0,
        device_type: 'web',
      };
      if (this.parlay) {
        this.calculateParlay();
        obj['parlay_potential_win'] = this.to_win;
        obj['stake_input_parlay'] = this.total_stake;
      }
      this._common.startLoading();
      let res = await this._sport.placePicks(obj);
      this._common.stopLoading();
      if (res.status) {
        this._sport.pickslip.next([]);
        this._sport.market_ids = [];
        this.parlay = false;
        this.parlayAmount = 0;
        this.confirm = false;
        this.to_win = 0;
        this.total_stake = 0;
        this._toast.success('Pick(s) Placed');
        this.straight = '';
      } else {
        this.errorid = res.marketid || [];
        this._toast.error(res.message);
        if (this.errorid.length) {
          slips.forEach((slip, index) => {
            if (!this.errorid.includes(slip.market_id)) {
              this.removeItem(index);
            }
          });
        }
      }
    } else if (minMax < 50) {
      this._toast.error('Minimum pick amount should be $50.');
    } else {
      this._toast.error('Maximum pick amount should be $1000.');
    }
    return;
  }

  totalStake(slips: any) {
    let value = 0;
    slips.forEach((slip: any) => {
      value += parseInt(slip.bet_amount);
    });
    return value;
  }

  towin(slips: any) {
    let value = 0;
    slips.forEach((slip: any) => {
      value += Math.round((slip.odd - 1) * slip.bet_amount);
    });
    return value;
  }

  calculateParlay() {
    this.total_stake = this.parlayAmount;
    let value = 1;
    let slips = this._sport.pickslip.getValue();
    slips.forEach((slip: any) => {
      value *= slip.odd;
    });
    this.to_win = (value - 1) * this.parlayAmount;
  }
}
